var NumberFormat = /** @class */ (function () {
    function NumberFormat(column) {
        this.column = column;
        this.setting = column.$el[0].querySelector('.ac-column-setting--number_format');
        if (!this.setting) {
            return;
        }
        this.bindEvents();
    }
    NumberFormat.prototype.bindEvents = function () {
        var _this = this;
        this.refreshPreview();
        this.setting.querySelectorAll('input').forEach(function (el) {
            el.addEventListener('change', function (e) {
                _this.refreshPreview();
            });
        });
    };
    NumberFormat.prototype.refreshPreview = function () {
        var _this = this;
        this.getExampleRequest().done(function (example) {
            var preview = _this.setting.querySelector('[data-preview]');
            if (preview) {
                preview.innerText = example;
            }
        });
    };
    NumberFormat.prototype.getExampleRequest = function () {
        var decimals = this.setting.querySelector('.ac-setting-input_number_decimals');
        var decimal_point = this.setting.querySelector('.ac-setting-input_number_decimal_point');
        var thousands_point = this.setting.querySelector('.ac-setting-input_number_thousands_separator');
        return jQuery.ajax({
            url: ajaxurl,
            method: 'post',
            data: {
                action: 'ac_number_format',
                number: 7500,
                decimals: decimals ? decimals.value : '',
                decimal_point: decimal_point ? decimal_point.value : '',
                thousands_point: thousands_point ? thousands_point.value : '',
            }
        });
    };
    return NumberFormat;
}());
var numberformat = function (column) {
    column.settings.number_format = new NumberFormat(column);
};
export default numberformat;
